//--------------------------------------------------------------------//
//******************** deploymentsTable ********************************//
//--------------------------------------------------------------------//
// Renders the deployments listing table and handles deployment interactions.
// Displays slug, status badge, and an active toggle switch per row.
// Clicking a row re-fetches the deployment and opens a full-screen popup
// with Info and Console tabs. Delete action shows a confirmation dialog.
import './deployments.scss';
import './deployments.service.js';
import './deployment-info/deployment-info.tab.js';
import './deployment-console/deployment-console.tab.js';
import { GUDHUB_SETTINGS } from '../../config.js';

angular.module('deploymentsTableModule')

    .directive('deploymentsTable', ['GhDialog', 'DeploymentsService', function (GhDialog, DeploymentsService) {
        return {
            restrict: 'E',
            scope: {
                deployments: '='
            },

            controller: ['$scope', 'localizationService', function ($scope, localizationService) {
                const dictionary = localizationService.getDictionary('account_settings');
                $scope.translate = (word) => localizationService.translate(word, dictionary);

                if (!Array.isArray($scope.deployments)) {
                    $scope.deployments = [];
                }

                $scope.$watchCollection('deployments', function (newValue) {
                    if (!Array.isArray(newValue)) {
                        $scope.deployments = [];
                    }
                });

                $scope.getStatusLabel = function (status) {
                    return DeploymentsService.getStatusLabel(status);
                };

                $scope.getStatusClass = function (status) {
                    return DeploymentsService.getStatusClass(status);
                };

                // The reverse-proxy URL this deployment is served at once running.
                $scope.getAppUrl = function (deployment) {
                    return GUDHUB_SETTINGS.deployment_manager_server_url + '/' + deployment.slug + '/';
                };

                // Opens a confirmation dialog to delete a deployment. On confirm,
                // calls the API and removes the deployment from the list.
                $scope.showDeleteDeploymentPopup = function (deployment) {
                    const tableScope = $scope;

                    GhDialog.show({
                        position: 'center',
                        toolbar: false,
                        template: {
                            toolbar: '',
                            resizable: false,
                            content: `
                                <div class="delete_deployment-popup">
                                    <div class="dialog-share-group">
                                        <span gh-icon="rubbish FF0D0D 65px"></span>
                                        <p class="dialog-share-group__title">{{translate('Deleting Deployment!')}}</p>
                                    </div>

                                    <div class="dialog-share-group__content">
                                        <p class="info">
                                            {{translate('Do you really want to delete this deployment? Its container will be stopped and removed, and you will not be able to restore it.')}}
                                        </p>

                                        <div class="dialog-share-group__content__buttons">
                                            <button
                                                class="dialog-share-group__content__buttons__add btn btn-blue-reverse"
                                                ng-click="deleteDeployment()"
                                                ng-disabled="deleting"
                                            >
                                                {{deleting ? translate('Deleting...') : translate('Delete')}}
                                            </button>

                                            <button
                                                class="dialog-share-group__content__buttons__cancel btn btn-blue"
                                                ng-click="cancel()"
                                            >
                                                {{translate('Cancel')}}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            `
                        },
                        locals: {
                            deployment
                        },
                        controller: [
                            '$scope',
                            'deployment',
                            'localizationService',
                            'DeploymentsService',
                            function ($scope, deployment, localizationService, DeploymentsService) {
                                const dictionary = localizationService.getDictionary('account_settings');
                                $scope.translate = (word) => localizationService.translate(word, dictionary);
                                $scope.deleting = false;

                                $scope.deleteDeployment = async function () {
                                    $scope.deleting = true;
                                    try {
                                        await DeploymentsService.delete(deployment._id);

                                        if (!Array.isArray(tableScope.deployments)) {
                                            tableScope.deployments = [];
                                        }

                                        const index = tableScope.deployments.findIndex(function (d) {
                                            return d._id === deployment._id;
                                        });

                                        if (index !== -1) {
                                            tableScope.deployments.splice(index, 1);
                                        }

                                        tableScope.$applyAsync();
                                        $scope.cancel();
                                    } catch (error) {
                                        console.log('Deployment delete error:', error);
                                        $scope.deleting = false;
                                        $scope.$applyAsync();
                                    }
                                };
                            }
                        ]
                    });
                };

                // Opens the full-screen deployment detail popup with Info and Console tabs.
                // Re-fetches the deployment first so a redeploy/toggle that finished in
                // the background since the list was last loaded isn't shown stale.
                $scope.openDeployment = async function (e, deployment) {
                    const tableScope = $scope;

                    let fresh = deployment;
                    try {
                        fresh = await DeploymentsService.getOne(deployment._id);
                        Object.assign(deployment, fresh);
                    } catch (error) {
                        console.log('Failed to refresh deployment before opening:', error);
                    }

                    GhDialog.show({
                        position: 'full',
                        toolbar: false,
                        template: {
                            toolbar: '',
                            content: `
                                <div class="deployment-popup">
                                    <div class="deployment-popup__header">
                                        <div class="deployment-name-wrapper">
                                            <div class="deployment_name_input">{{deployment.slug}}</div>
                                        </div>

                                        <span
                                            class="close_dialog"
                                            ng-click="cancel()"
                                            gh-icon="cross #0D99FF 30px"
                                        ></span>
                                    </div>

                                    <div class="deployment-popup__nav-panes">
                                    <div class="deployment-popup__nav-track" ng-class="{'--detail_open': tabDetailOpen}">
                                    <div class="deployment-popup__tabs">
                                        <div class="deployment-popup__tab"
                                             ng-class="{'deployment-popup__tab--active': activeTab === 'info'}"
                                             ng-click="activeTab = 'info'; tabDetailOpen = true;">
                                            {{translate('Info')}}
                                            <span class="deployment-popup__tab-chevron" gh-icon="arrow_right a7a9b3 20px normal"></span>
                                        </div>
                                        <div class="deployment-popup__tab"
                                             ng-class="{'deployment-popup__tab--active': activeTab === 'console'}"
                                             ng-click="activeTab = 'console'; tabDetailOpen = true;">
                                            {{translate('Console')}}
                                            <span class="deployment-popup__tab-chevron" gh-icon="arrow_right a7a9b3 20px normal"></span>
                                        </div>
                                    </div>

                                    <div class="deployment-popup__content-pane">
                                    <div class="deployment-popup__mobile-header">
                                        <span class="deployment-popup__mobile-back" ng-click="tabDetailOpen = false">
                                            <span gh-icon="arrow_left 0893d2 24px normal"></span>
                                        </span>
                                        <span ng-if="activeTab === 'info'">{{translate('Info')}}</span>
                                        <span ng-if="activeTab === 'console'">{{translate('Console')}}</span>
                                    </div>
                                    <div class="deployment-popup__content">
                                        <div class="deployment-info" ng-show="activeTab === 'info'">
                                            <deployment-info-tab deployment="deployment" on-update="onDeploymentUpdate()"></deployment-info-tab>
                                        </div>

                                        <div class="deployment-console" ng-show="activeTab === 'console'">
                                            <deployment-console-tab deployment="deployment"></deployment-console-tab>
                                        </div>
                                    </div>
                                    </div>
                                    </div>
                                    </div>
                                </div>
                            `
                        },
                        locals: {
                            deployment
                        },
                        controller: ['$scope', 'deployment', 'localizationService', function ($scope, deployment, localizationService) {
                            const dictionary = localizationService.getDictionary('account_settings');
                            $scope.translate = (word) => localizationService.translate(word, dictionary);
                            $scope.deployment = deployment;
                            $scope.activeTab = 'info';
                            $scope.tabDetailOpen = false;

                            $scope.onDeploymentUpdate = function () {
                                tableScope.$applyAsync();
                            };
                        }]
                    });
                };
            }],

            template: `
                <div class="listing_table">
                    <div class="listing_table_head_wrapper">
                        <div class="listing_table_column bottom_line w-40">
                            <div class="tab">{{translate('Name')}}</div>
                        </div>

                        <div class="listing_table_column w-25">
                            <div class="tab">{{translate('Status')}}</div>
                        </div>

                        <div class="listing_table_column w-25">
                            <div class="tab">{{translate('Link')}}</div>
                        </div>

                        <div class="listing_table_column w-10"></div>
                    </div>

                    <div class="listing_table_body_wrapper">
                        <div
                            class="listing_table_row"
                            ng-click="openDeployment($event, deployment)"
                            ng-repeat="deployment in deployments track by deployment._id"
                        >
                            <div class="listing_table_column w-40">
                                <span class="number">{{$index + 1}}</span>
                                <div class="name">{{deployment.slug}}</div>
                            </div>

                            <div class="listing_table_column w-25">
                                <span
                                    class="status-badge"
                                    ng-class="getStatusClass(deployment.status)"
                                >
                                    {{getStatusLabel(deployment.status)}}
                                </span>
                            </div>

                            <div class="listing_table_column w-25">
                                <a
                                    ng-if="deployment.status === 'running'"
                                    ng-href="{{getAppUrl(deployment)}}"
                                    target="_blank"
                                    rel="noopener"
                                    ng-click="$event.stopPropagation()"
                                    class="open_app_link"
                                >
                                    <span gh-icon="link 0d99ff 18px"></span>
                                    {{translate('Open')}}
                                </a>
                            </div>

                            <div class="listing_table_column w-10">
                                <span
                                    ng-click="showDeleteDeploymentPopup(deployment); $event.stopPropagation()"
                                    class="delete_icon"
                                    gh-icon="rubbish 0d99ff 20px"
                                ></span>
                            </div>
                        </div>

                        <div ng-if="!deployments.length" class="listing_table_nodata">
                            <p>{{translate('No Deployments')}}</p>
                        </div>
                    </div>
                </div>
            `
        };
    }]);
